import { default as fetch } from '@n2-common/lib/fetchProxy';
import { checkFor401AndMaybeLoadLoggedOutPage, parseJsonResponseWithDate } from '@n2-common/lib/FetchHelpers';
import { DueDiligenceStatus } from '@n2-common/serverGeneratedTypings/dueDiligenceStatus';
import { PepStatusResponse } from '@n2-common/serverGeneratedTypings/pepStatusResponse';
import { CddAnswer } from '@n2-common/serverGeneratedTypings/cddAnswer';
import { SubmitOddAnswerModel } from '@n2-common/serverGeneratedTypings/submitOddAnswerModel';
import { SubmitOddAnswersResponse } from '@n2-common/serverGeneratedTypings/submitOddAnswersResponse';
import { DueDiligenceQuestionsModel } from '@n2-common/serverGeneratedTypings/dueDiligenceQuestionsModel';
import { UploadDocumentResponse } from '@n2-common/serverGeneratedTypings/uploadDocumentResponse';

export async function getOddStatus(): Promise<DueDiligenceStatus> {
    const requestUrl = `/api/n2/mypage/odd/status`;

    const response = await fetch(requestUrl, { method: 'GET', redirect: 'error' });
    checkFor401AndMaybeLoadLoggedOutPage(response);
    return parseJsonResponseWithDate<DueDiligenceStatus>(response);
}

export async function getOddQuestions(): Promise<DueDiligenceQuestionsModel> {
    const requestUrl = `/api/n2/mypage/odd/questions`;

    const response = await fetch(requestUrl, { method: 'GET', redirect: 'error' });
    checkFor401AndMaybeLoadLoggedOutPage(response);
    return parseJsonResponseWithDate<DueDiligenceQuestionsModel>(response);
}

export async function postOddAnswers(payload: CddAnswer[], includesEnhanced: boolean, submissionId: string) {
    const requestUrl = `/api/n2/mypage/odd/answers`;
    const model: SubmitOddAnswerModel = {
        CddQuestionsWithAnswers: payload,
        IncludesEnhanced: includesEnhanced,
        SubmissionId: submissionId
    };
    const response = await fetch(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'error',
        body: JSON.stringify(model),
    });
     checkFor401AndMaybeLoadLoggedOutPage(response);
    return parseJsonResponseWithDate<SubmitOddAnswersResponse>(response);

}

export async function uploadOddDocument(documentKey: string, data: FormData): Promise<UploadDocumentResponse> {
    const response = await fetch(
        `/api/n2/mypage/odd/document?documentKey=${documentKey}`,
        {
            method: 'POST',
            body: data,
        }
    );
    checkFor401AndMaybeLoadLoggedOutPage(response);
    const res = (await response.json()) as UploadDocumentResponse;
    return res;
}

export async function getPepStatus(): Promise<PepStatusResponse> {
    const requestUrl = `/api/n2/mypage/odd/pepStatus`;

    const response = await fetch(requestUrl, { method: 'GET', redirect: 'error' });
    checkFor401AndMaybeLoadLoggedOutPage(response);
    return parseJsonResponseWithDate<PepStatusResponse>(response);
}
